
import axios from "axios";
import appconst from "@/lib/appconst";
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";

import SchoolSelector from "../payment/components/school-selector.vue";

import { CustomizedPushNotificationPageDto,CreateCustomizedPushNotificationDto,CustomizedPushNotificationService
  ,GradeInfoListDto,ProductService,ProductDto
 } from "@/api/service-proxies";

import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import { dateTime } from "@/lib";

class CustomizedPushRequest extends PagedRequestDto {
  tenantId!:number;
  productId!:number;
  content!:string;
  customizedPush!:number;

}

@Component({
  name: "Tenant",
  components: {
    Pagination,SchoolSelector
  }
})
export default class CustomizedPush extends PagedListBase<
  CustomizedPushRequest,
  CustomizedPushNotificationPageDto
> {
  request = new CustomizedPushRequest();
  gradeInfByTenantId : GradeInfoListDto[]=[]
  productList : ProductDto[]=[]
  dialogVisible = false
  submitLoadding =false
  gradeNoArray = [];
  isTableLoading = false;
  createItem = new CreateCustomizedPushNotificationDto({customizedPush:0});
  service = new CustomizedPushNotificationService();
  productService = new ProductService();
  $http: any
  created() {
    this.getProducePage()
    this.refresh();
  }
  getpage(): void {
    this.isTableLoading = true;
    this.service.getCustomizedPushNotificationPage(
      this.request.tenantId,
      this.request.productId,
      this.request.content,
      this.request.customizedPush,
      this.request.skipCount,
      this.request.maxResultCount,
      )
      .then(result => {
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        this.isTableLoading = false;
      });

    }
  createCustomPush(){
    this.dialogVisible = true;
  }
  tenantChangeQuery(e){
    this.request.tenantId =e.tenantId;
  }

  getProducePage(){
    this.productService
      .getAll(
        null,
        null,
        null,
        null,
        null,
        0,
        999
      )
      .then(result => {
        this.productList = result.items;
      })
      .finally(() => {

      });
  }
  ///学校变化 导致班级数据变化
  tenantChange(e) {
    this.createItem.tenantId = e.tenantId
    this.createItem.tenantName = e.name
    this.gradeNoArray = [];
    this.service.getGradeInfoListDto(e.tenantId)
    .then((res)=>{
      this.gradeInfByTenantId = res;
    })
  }

  customizedPushChange(e){
    if(this.createItem.customizedPush == 0){
      this.createItem.relevantName = "阳光少年"
    }
  }

  //提交自动义推送
  submit(){
    if(this.createItem.tenantId == null ||this.createItem.tenantId == undefined)
    {
      this.$message.warning("请选择需要推送的学校")
      return;
    }
    if(this.gradeNoArray.length == 0)
    {
      this.$message.warning("请选择需要推送的相关年级")
      return;
    }
    if(this.createItem.content == undefined || this.createItem.content == null ||this.createItem.content.trim().length == 0)
    {
      this.$message.warning("通知内容不能为空")
      return;
    }
    if(this.createItem.customizedPush == 1 && (this.createItem.relevantId == null||this.createItem.relevantId == undefined))
    {
      this.$message.warning("通知类型为产品的时候需要选择具体产品信息")
      return;
    }
    this.submitLoadding = true;
    this.createItem.gradeNoArrayStr = this.gradeNoArray.join(',')
    //连接名字
    if(this.createItem.customizedPush == 1){
      this.createItem.relevantName = this.productList.find(x=>x.id == this.createItem.relevantId).name
    }
    this.service.createCustomizedPushNotification(this.createItem)
    .then(()=>{
      this.$message.success("提交成功")
      this.dialogVisible = false;
      this.getpage();
    })
    .catch((e)=>{
      this.$message.error("提交数据失败:"+e.message)
    })
    .finally(()=>{
      this.submitLoadding =false
    })
  }

  //再次推送
  pushAgain(row){
    this.service.geteCustomizedPushNotificationPushAgain(row.id,row.tenantId)
    .then(()=>{
      this.$message.success("再次推送成功！");
    })
    .catch((e)=>{
      this.$message.error("再次推送成功："+e.message);
    })
  }


}
